import React from "react";
import styled from "styled-components";
import ActivityIndicator from "./ActivityIndicator";
interface Props {
  loading?: boolean;
  size?: "sm" | "md" | "lg";
}

const Loading: React.FC<Props> = (props) => {
  const { loading, children, size = "md" } = props;
  return (
    <>
      <Container style={{ display: !loading ? "none" : "flex" }}>
        <Overlay />
        <ActivityIndicator size={size} loading={loading} />
      </Container>
      {children}
    </>
  );
};

export default Loading;

const Container = styled("div")({
  zIndex: 999,
  position: "absolute",
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,
  background: "transparent",
  display: "flex",
  flex: 1,
  justifyContent: "center",
  alignItems: "center",
});

const Overlay = styled("div")({
  position: "absolute",
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,
  background: "transparent",
  display: "flex",
  flex: 1,
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#c7cbd1",
  opacity: 0.4,
})